import script from "./EmptyV1.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyV1.vue?vue&type=script&setup=true&lang=js"

import "./EmptyV1.vue?vue&type=style&index=0&id=6bdab81c&lang=css"

const __exports__ = script;

export default __exports__